import DeleteIcon from '@atlaskit/icon/core/delete';
import { HIGHLIGHT_DELETE_CLASS } from '@databases/highlights/constants';
import { messages } from '@databases/intl/messages';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types';
import { ElementBeforeIconWrapper } from '../../../select-value-menu/ui/components';
import { CONTEXT_MENU_DELETE_PREVIEW_Z_INDEX } from '../../constants';
import { type SelectionsEffectMenuItemBuilder } from '../types';

const CONTEXT_MENU_DELETE_ROW_HIGHLIGHT_ID = 'context-menu-delete-row';

export const deleteCurrentRowMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  actions,
  skip
) => {
  if (!context.capabilities.canDeleteEntries) {
    return skip;
  }

  return () => ({
    key: SELECT_VALUE_MENU_ACTIONS.DELETE_ENTRIES,
    content: context.formatMessage(messages['entry-actions.delete'], {
      entryCount: '1',
    }),
    onClick: () => {
      actions.cell.handleDeleteEntries();
      context.selectionsActions.clearSelectionIntent();
      context.closeMenu();
    },
    onMouseEnter: () => {
      const layer = context.deletePreviewLayer;
      const resolve = context.resolveEntryIdToRowIndex;

      if (layer && resolve) {
        const rowIndex = resolve(context.entryId);

        if (rowIndex >= 0) {
          layer.add({
            range: {
              id: CONTEXT_MENU_DELETE_ROW_HIGHLIGHT_ID,
              anchor: { row: rowIndex, col: 0 },
              lead: { row: rowIndex, col: 0 },
            },
            mode: 'row',
            zIndex: CONTEXT_MENU_DELETE_PREVIEW_Z_INDEX,
            className: HIGHLIGHT_DELETE_CLASS,
          });
        }
      }
    },
    onMouseLeave: () => {
      context.deletePreviewLayer?.remove(CONTEXT_MENU_DELETE_ROW_HIGHLIGHT_ID);
    },
    elemBefore: (
      <ElementBeforeIconWrapper>
        <DeleteIcon label="" spacing="spacious" />
      </ElementBeforeIconWrapper>
    ),
  });
};
